import {Card, CardContent, FlexContainer} from "@axxes/design-system";
import React from "react";
import {EditTrainingCourses} from "../components/EditTrainingCourses/EditTrainingCourses";

export const ManageTrainingDataContainer = () => {
    return <FlexContainer
        direction="column"
        customClasses="axxes-manage__edit"
        padding="0"
    >
        <FlexContainer
            direction="row"
            padding="0"
        >
            <h1>Manage Trainings Data</h1>
        </FlexContainer>
        <FlexContainer
            direction="column"
            padding="0"
            customClasses="axxes-manage__card"
        >
            <Card>
                <CardContent>
                    <EditTrainingCourses/>
                </CardContent>
            </Card>
        </FlexContainer>
    </FlexContainer>
}